import { Injectable } from '@nestjs/common';
import { AssociatesResponse, CompanyIdRequest, DepartmentDropResponse, GlobalResponseObject } from '@schemax-whatsapp/shared-models';
import { BiMessageService } from '@schemax-whatsapp/shared-services/whatsapp-api';
import { HrmsDbConnectionService } from '../db-connections/hrms-db-connection.service';

import { CompanyDeptRoleCategoryCodeRequest } from './model/company-dept-role-cat.request';

@Injectable()
export class WhatsappBroadCastService {
    constructor(
        private dbConnectionService: HrmsDbConnectionService,
        private service :BiMessageService
    ) { }

}
